module.exports = __webpack_public_path__ + "media/images/signatures/kamill_signature_black-80d9004d2e40837e050fa09441c17158.jpg";